import { useAppStore, useFilterStore } from '@/shared/store'
import { FilterCategory } from '@/shared/store/types'
import { useTranslation } from 'react-i18next'
import { sortObjectsById } from '@/shared/lib'
import { getWithAuth } from '@/api/httpRequests'
import { channelsCategoriesEndpoint } from '@/api/apiConstants'
import { epgCategoryRequest } from '@/types/epg/epgCategoryRequest'
import { useEPGStore } from '@/shared/store'

const useCategoriesForFiltering = () => {
    const { setFilterCategories } = useFilterStore()
    const { epgData } = useEPGStore()
    const { t: translate } = useTranslation()
    const { isGuest } = useAppStore()

    const getCategoriesForFiltering = async () => {
        const categoriesData: epgCategoryRequest[] = await getWithAuth(
            channelsCategoriesEndpoint
        )
        const categories: FilterCategory[] = []

        categoriesData.forEach((category: epgCategoryRequest) => {
            const { name, id } = category
            const allCategoriesList = new Set([name])

            allCategoriesList.forEach((allCategoriesList) => {
                const existingObject = categories.find(
                    (obj) => obj.name === allCategoriesList
                )

                if (existingObject) {
                    existingObject.itemsAmount += 1
                } else {
                    categories.push({
                        itemId: id,
                        name: allCategoriesList,
                        itemsAmount: 1,
                    })
                }
            })
        })
        const categoriesArray = Array.from(categories)
        const sortedArray = sortObjectsById(
            categoriesArray,
            (obj) => obj.itemId
        )

        if (!isGuest) {
            sortedArray.unshift({
                itemId: '-1',
                name: translate('genreFavorites'),
                itemsAmount: 0,
            })
        }

        const filters = sortedArray.filter((item) => item.name !== 'kids')
        setFilterCategories(filters)
    }

    return { getCategoriesForFiltering }
}

export { useCategoriesForFiltering }
